/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Email_TakenInputs */

const es_co2_error_email_taken = /** @type {(inputs: Error_Email_TakenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Este correo electrónico ya está registrado.`)
};

/**

* @param {Error_Email_TakenInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_email_taken = /** @type {((inputs?: Error_Email_TakenInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Email_TakenInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_email_taken(inputs)
});